export const defaultColumns = [
  {label: 'Categoria', value: 'display_name'}, 
  {label: 'Produtos cadastrados', value: 'products_count', className: 'w-[200px]'},
  {label: 'Ações', value: 'actions', className: 'w-9'},
]